<form nz-form [formGroup]="justificativaForm" (ngSubmit)="salvarObservacoes()">
  <div class="row">
    <textarea nz-input rows="4" formControlName="textoJustificativa" ></textarea>
  </div>

  <div class="row gap-3 justify-content-end mt-3">
    <button style="width: initial;" class="flex-1" nz-button nzType="default" type="button" (click)="fecharModal()">Cancelar</button>
    <button style="width: initial;" class="flex-1" nz-button nzType="primary" type="submit" [disabled]="justificativaForm.invalid" class="ms-2">Adicionar</button>
  </div>
</form>
